import { EstablishmentLote } from "@/services/establishments.service";
import { AppColors } from "@/styles/colors";
import { Box, Button, Flex, Grid, Text } from "@chakra-ui/react";

interface Props {
  lotes: EstablishmentLote[];
  onVerEnMapa: (lote: EstablishmentLote) => void;
}

export const LotesTable = ({
  lotes,
  onVerEnMapa,
}: Props) => {
const LOTES_COLUMNS = "2fr 2fr 120px 150px 110px";

  if (!lotes?.length) {
    return (
      <Text fontSize="14px" color={AppColors.GRAY_TEXT_ALT} paddingY="12px">
        Sin lotes disponibles.
      </Text>
    );
  }

  return (
    <Flex flexDir="column" bg={AppColors.BACKGROUND_SECONDARY} borderRadius="6px" overflow="hidden">
      <Grid
        templateColumns={LOTES_COLUMNS}
        paddingY="8px"
        paddingX="12px"
        borderBottom={`1px solid ${AppColors.WHITE_BORDER_1}`}
      >
        <Text fontWeight={600} fontSize="13px">Lote</Text>
        <Text fontWeight={600} fontSize="13px">Código Agrobit</Text>
        <Text fontWeight={600} fontSize="13px">Hectáreas</Text>
        <Text fontWeight={600} fontSize="13px">Perímetro</Text>
        <Box />
      </Grid>
      {lotes.map((lote, idx) => (
        <Grid
          key={`${lote.id}-${idx}`}
          templateColumns={LOTES_COLUMNS}
          paddingY="10px"
          paddingX="12px"
          alignItems="center"
          borderBottom={`1px solid ${AppColors.WHITE_BORDER_1}`}
        >
          <Text fontSize="14px">{lote.nombreLote || "-"}</Text>
          <Text fontSize="14px">{lote.id || "-"}</Text>
          <Text fontSize="14px">{lote.hectareas ?? "-"}</Text>
          <Text fontSize="14px">{lote.perimetro || "-"}</Text>
          <Button
            height="28px"
            paddingX="10px"
            fontSize="13px"
            bg={AppColors.BLACK_BUTTON}
            color="white"
            onClick={() => onVerEnMapa(lote)}
          >
            Ver en mapa
          </Button>
        </Grid>
      ))}
    </Flex>
  );
};
